<template>
  <div class="pa-4">
    <h2 class="mb-3 text-center">
      {{ $t('servicesystem.common_objects.commonterms.success') }}
    </h2>
    <p class="text-center mb-12">
      {{ $t('servicesystem.loginform.text.password_set_body') }}
    </p>
    <p v-if="errorText" class="error--text text-center">{{ errorText }}</p>

    <WideBtn :text="$t('servicesystem.common_objects.commonterms.proccede')" color="var(--v-primary-base)"
      :loading="taskInProgress" @click="login()">
    </WideBtn>
    <WideBtn :text="$t('servicesystem.loginform.text.back_to_login')" color="var(--v-primary-base)"
      :disabled="taskInProgress" :filled="false" @click="$emit('cancel')">
    </WideBtn>
  </div>
</template>


<script>
import WideBtn from "@/components/WideBtn.vue";

export default {
  name: "ContinueForm",
  props: {
    email: String,
    password: String,
  },
  components: {
    WideBtn
  },
  mixins: [],

  data() {
    return {
      taskInProgress: false,
      errorText: "",
    };
  },

  methods: {
    login() {
      this.taskInProgress = true;
      this.$store.dispatch("serviceProviderLogin", {
        username: this.email,
        password: this.password,
      })
        .catch((error) => {
          this.errorText = error.response.data.Message;
        })
        .finally(() => {
          this.taskInProgress = false;
        });
    },
  },

  computed: {},

  watch: {},
};
</script>


<style lang="scss"></style>